import * as React from "react";
const SvgFeather = (props) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 128 128", contentScriptType: "text/ecmascript", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M13.2 113.2C12 34 115 87 114.2 14.2", style: {
  stroke: "red",
  fill: "none",
  strokeWidth: 3
}, transform: "translate(.35 .546)" }));
export default SvgFeather;
